<template>
    <div class="content-wrap">
        <!--顶部图片-->
        <img :src="banner.picurl" class="top-img" alt="加载失败" />
        <!--<div class="top-img" style="text-align: center; line-height: 183px; background: #EDEDED;">img</div>-->

        <!--卡片格式-->
        <div class="card info flb">
            <div class="flb">
                <img class="head-img" v-lazy="objUserInfo.icon" alt="">
                <div class="info-wrap">
                    <div class="info-con1">{{objUserInfo.rel_group_name}}：{{objUserInfo.name}}</div>
                    <div class="info-con2" v-if="objUserInfo.job_number.length">工号：{{objUserInfo.job_number}}</div>
                    <!-- <div class="info-con3">{{objUserInfo.order?objUserInfo.order:0}}单 {{objUserInfo.favorable?objUserInfo.favorable:0}}% 好评</div> -->
                </div>
            </div>
            <a :href="'tel:'+objUserInfo.phone">
                <img class="phone-icon" src="@/assets/images/user/house/phone-icon.png" alt="">
            </a>
            
        </div>

        <div class="card">
            <div class="card-title fls">
                <div class="card-title-block"></div>
                <div class="card-title-text">
                    合同信息
                </div>
            </div>
            <!--表格信息-->
            <div class="card-table">
                <table>
                    <tr>
                        <td>合同编号</td>
                        <td colspan="3">{{objMemorandumInfo.new_code}}</td>
                    </tr>
                   <!-- <tr class="td4">
                        <td>设备销售总价</td>
                        <td>{{objMemorandumInfo.new_salesamount}}</td>
                        <td>系统安装总价</td>
                        <td>{{objImportantInfo.install_amount}}</td>
                    </tr> -->
                    <tr>
                        <td>合同总金额</td>
                        <td colspan="3">{{objMemorandumInfo.new_totalamount}}</td>
                    </tr>
                    <!-- <tr>
                        <td>门店信息</td>
                        <td colspan="3">{{objImportantInfo.company}}</td>
                    </tr> -->
                    <tr class="td4">
                        <td>{{objUserInfo.rel_group_name}}</td>
                        <td>{{objImportantInfo.sales}}</td>
                        <td>联系电话</td>
                        <td>{{objImportantInfo.sales_phone}}</td>
                    </tr>
                    <tr class="td4">
                        <td>项目经理</td>
                        <td>{{objImportantInfo.project}}</td>
                        <td>联系电话</td>
                        <td>{{objImportantInfo.project_phone}}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="card" v-if="JSON.stringify(objMemorandumInfo)!='{}'">
            <div class="card-title flb">
                <div class="fls">
                    <div class="card-title-block"></div>
                    <div class="card-title-text">
                        主要设备
                    </div>
                </div>
                <!-- <div class="card-title-right" style="color: #858585">主机</div> -->
            </div>
            <div class="card-title flb" style="margin-top: 10px">
                <!-- <div class="fls">
                    <div class="card-title-block" style="visibility: hidden"></div>
                    <div class="card-title-text" style="font-size: 14px">
                        合同总价：{{objMemorandumInfo.new_totalamount}}元
                    </div>
                </div> -->
                <div class="flx"></div>
                <!-- <div class="card-title-right">合同总金额：{{objMemorandumInfo.new_totalamount}}元</div> -->
                <!-- <div class="card-title-right">设备销售总价：{{objMemorandumInfo.new_salesamount}}元</div> -->
            </div>
            <div class="product-list">
                <div class="product-item flb" v-for="(item,index) in objMachine.list" :key="index">
                    <img class="product-item-img" :src="item.img" alt="">
                    <div class="product-item-right">
                        <div class="text1">{{item.cate?item.cate:'分类名称(默认)'}}</div>
                        <div class="text2">{{item.name}}</div>
                        <div class="flb" style="margin-top: 22px">
                            <div class="text1" style="line-height: 20px;">共{{item.num}}件</div>
                            <!-- <div class="text3">价格：¥{{item.amount}}</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
     <!--   <div class="card">
            <div class="card-title fls">
                <div class="card-title-block"></div>
                <div class="card-title-text">
                    合同图片
                </div>
            </div>
            <div class="card-table">
                <div class="card_swiper">
                    <van-swipe class="swiper_img" :show-indicators="false" ref="vanswipetwo" :loop="false" @change="swipetwo">
                        <van-swipe-item v-for="(item,index) in arrFile" :key="index">
                            <div class="swipe_img_url" @click="getShow()">
                                <img v-lazy="item" alt="">
                            </div>
                        </van-swipe-item>
                    </van-swipe>
                    <div class="left_swiper" @click="prev('vanswipetwo')">
                        <img src="@/assets/images/pagin/left_swiper.png" alt="">
                    </div>
                    <div class="right_swiper" @click="next('vanswipetwo')">
                        <img src="@/assets/images/pagin/right_swiper.png" alt="">
                    </div>
                </div>
                <div class="file_list">
                    <div class="file_warp" :style="{'transform': 'translateX('+ nTranslateX +'px)'}">
                        <div v-for="(item,index) in arrFile" :key="index">
                            <div :class="[nSwiperIndex == index?'swiper_bg_url':'swiper_sm_url']">
                                <img v-lazy="item" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div class="sub-btn" @click="downloadContracts">合同图片下载</div> -->
        <!-- 预览图片 -->
       <!-- <van-image-preview v-model="pdfShow" :closeable="true" :startPosition="nSwiperIndex" :images="arrFile">
            <template v-slot:nSwiperIndex>第{{ nSwiperIndex }}页</template>
        </van-image-preview> -->
    </div>
</template>

<script>
import {getMemorandumInfo,downloadContract} from '@/js/house/index'
export default {
    // 勘察报告
    name: "surveyReport",
    data(){
        return{
            objUserInfo:{
                job_number:[],
            },//用户信息
            pdfShow:false,
            nSwiperIndex: 0, //轮播图索引
            objMemorandumInfo:{},//所有信息
            objMachine:{},//主机信息
            objDistribution:{},//输配
            objControl:{},//控制器
            objOtherMachine:{},//辅材
            objOther:{},//人工及其他
            nContractId:0,//合同id
            objImportantInfo:{},//重要信息
            arrFile:[],//合同图片
        }
    },
    created() {
      let contractId = this.$route.query.contractId
      this.nContractId=contractId
        $init(() => {
            this.$store.commit("loadSkeleton", { bool: true, type: "mapping" }); // 页面loading开启
            this.$store.dispatch("banner/getData", 10);
            Promise.all([this.getMemorandum(),this.downloadContracts()]).then(res => {
                this.$store.commit("loadSkeleton", { bool: false, type: "mapping" }); // 页面loading开启
            })
        });
    },
    computed: {
        banner() {
            return this.$store.state.banner.remark;
        },
        nTranslateX: function () {
            if (this.arrFile != undefined) {
                if (
                    this.arrFile &&
                    this.nSwiperIndex < this.arrFile.length - 1
                ) {
                    if (this.nSwiperIndex > 0) {
                        return 110 * (this.nSwiperIndex - 1) * -1;
                    } else if (this.nSwiperIndex == 0) {
                        return 0;
                    }
                }
            }
        },
    },
    methods:{
        prev(type) {
            let _that = this;
            _that.$refs[type].prev();
        },
        next(type) {
            let _that = this;
            _that.$refs[type].next();
        },
        // 轮播图滑动
        swipetwo(e) {
            this.nSwiperIndex = e;
        },
        getShow(e) {
            this.pdfShow = true;
        },
        // 下载合同
        downloadContracts(){
            downloadContract({id:this.nContractId}).then(res=>{
                this.arrFile = res.data.data.result;
            })
        },
        getMemorandum(){
            getMemorandumInfo({id:this.nContractId}).then(res=>{
                this.objMemorandumInfo=res.data.data.result
                this.objMachine=res.data.data.result.main_machine
                this.objDistribution=res.data.data.result.distribution//输配
                this.objControl=res.data.data.result.control//控制
                this.objOtherMachine=res.data.data.result.other_machine//辅材
                this.objOther=res.data.data.result.other//其他
                this.objUserInfo=res.data.data.result.sign_user//用户信息
                this.objImportantInfo=res.data.data.result.important//重要信息
                console.log(this.objMemorandumInfo,'备忘录')
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.content-wrap {
    min-height: 100vh;
    background: $commonBgColor;
    position: relative;
    padding-bottom: 20px;
    box-sizing: border-box;

    /*顶部图片*/
    .top-img {
        width: 100%;
        height: 366px;
    }
.common-table{
  tr{
    &:last-child {
      display: none;
    }
  }
}
    /*card*/
    .card {
        width: 93.6%;
        margin: 28px auto 0;
        background: #fff;
        border-radius: $commonRadius;
        padding: 24px;

        /*标题*/
        .card-title {
            .card-title-block {
                width: 6px;
                height: 32px;
                background: $deepGreen;
                margin-right: 12px;
            }

            .card-title-text {
                font-size: $bigSize;
                font-weight: 500;
                color: $defaultBlack;
                line-height: 44px;
            }

            .card-title-right {
                font-size: $baseSize;
                font-weight: 400;
                color: $commonTitle;
                line-height: 40px;
            }
        }

        /*表格*/
        .card-table {
            width: 100%;
            margin: 20px 0 4px;
            .file_list{
                display: flex;
                width: 100%;
                margin-top: 20px;
                padding-top: 20px;
                border-top: 1px solid #e5e5e5;
                overflow: hidden;
                .file_warp{
                    display: flex;
                    // white-space: nowrap; /* ul中的内容不换行 */
                    transform: translateX(0);
                    box-sizing: border-box;
                    div{
                        margin-right: 20px;
                        width: 200px;
                        height: 150px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .swiper_bg_url {
                            width: 200px;
                            height: 150px;
                            transition: all 1s;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            overflow: hidden;
                            background: #e5e5e5;
                            img {
                                width: 100%;
                            }
                        }
                        .swiper_sm_url {
                            background: #e5e5e5;
                            width: 180px;
                            height: 140px;
                            transition: all 1s;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            overflow: hidden;
                            img {
                                width: 100%;
                            }
                        }
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }
            table {
                width: 100%;
                border: 2px solid #e5e5e5;
                text-align: center;
                // line-height: 74px;
                font-size: $smallSize;
                font-weight: 400;
                color: #858585;
                td{
                  padding: 20px 0;
                }
                th{
                  padding: 24px 0;
                }

                tr {
                    width: 100%;
                    border-bottom: 2px solid #e5e5e5;
                    &:last-child {
                        border-bottom: none;
                    }

                    th {
                        border-right: 2px solid #e5e5e5;

                        &:last-child {
                            border-right: none;
                        }
                    }

                    td {
                        border-right: 2px solid #e5e5e5;

                        &:first-child {
                            width: 25%;
                        }

                        &:last-child {
                            border-right: none;
                        }
                    }
                    .company-name {
                        text-align: left;
                        text-indent: 10px;
                    }
                }

                .td4 {
                    width: 100%;
                    td {
                        width: 25%;
                    }
                }

                .special {
                    td {
                        height: 180px;
                        line-height: 32px;

                        .td-wrap {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
            }

            .common-table {
                color: $commonText;
            }
        }

        /*产品列表*/
        .product-list {
            width: 100%;
            padding: 10px 0 8px;
            border-top: 2px dashed #f1f1f1;
            margin-top: 28px;

            .product-item {
                padding: 20px 0;
                border-bottom: 2px dashed #f1f1f1;

                &:last-child {
                    padding-bottom: 0;
                    border-bottom: none;
                }

                .product-item-img {
                    width: 202px;
                }

                .product-item-right {
                    margin-left: 24px;
                    width: 66%;

                    .text1 {
                        font-size: $baseSize;
                        font-weight: 400;
                        color: $commonTitle;
                        line-height: 54px;
                    }
                    .text2 {
                        font-size: $baseSize;
                        font-weight: 400;
                        color: $viceText;
                        line-height: 54px;
                    }
                    .text3 {
                        font-size: $baseSize;
                        font-weight: 500;
                        color: $warnText;
                        line-height: 40px;
                    }
                }
            }
        }
    }

    .info {
        padding: 28px 24px;
        .head-img,
        .phone-icon {
            width: 120px;
            height: 120px;
        }

        .info-wrap {
            margin-left: 20px;

            .info-con1 {
                font-size: $baseSize;
                font-weight: 500;
                color: $commonTitle;
                line-height: 40px;
            }
            .info-con2 {
                font-size: $smallSize;
                font-weight: 400;
                color: #a2a2a2;
                line-height: 34px;
            }
            .info-con3 {
                font-size: $smallSize;
                font-weight: 400;
                color: #318544;
                line-height: 46px;
            }
        }
    }

    /*button*/
    .sub-btn {
        width: 93.6%;
        height: 100px;
        background: $userBgGradient;
        border-radius: $commonRadius;
        margin: 96px auto 68px;

        font-size: $bigSize;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 100px;
    }

    .help-img {
        width: 156px;
        height: 156px;
        position: fixed;
        right: 0;
        bottom: 230px;
    }
}

/*通用样式*/
.flc {
    display: flex;
    align-items: center;
    justify-content: center;
}

.fls {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.flb {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.card_swiper{
    position: relative;
    .left_swiper {
        position: absolute;
        width: 34px;
        height: 48px;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto 0;
        img {
            width: 34px;
            height: 48px;
        }
    }
    .right_swiper {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        right: 0;
        width: 34px;
        height: 48px;
        img {
            width: 34px;
            height: 48px;
        }
    }
}
.swiper_img {
    width: 100%;
    height: 580px;
    position: relative;
    margin-top: 8px;
    .swipe_img_url {
        width: 100%;
        height: 580px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        .swipe_img_label {
            width: 140px;
            height: 56px;
            background: rgba(0, 0, 0, 0.4);
            border-radius: 0px 12px 0px 12px;
            color: #fff;
            position: absolute;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
        }
        .swipe_img_label_green {
            width: 140px;
            height: 56px;
            background: #318544;
            border-radius: 0px 12px 0px 12px;
            color: #fff;
            position: absolute;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
        }
        img {
            width: 100%;
            // height: 320px;
        }
    }
}
</style>